export default __webpack_public_path__ + "static/media/2489.b0837b6c.png";